module.exports = __webpack_public_path__ + "static/img/yz1.4076514d.png";